import React from 'react';
import ReactDOM from 'react-dom/client';
import App from '@/app/App';
import './polyfills';

const importRegion = async () => {
    try {
        const url = import.meta.env.DEV ? 'http://localhost:3090' : window.location.origin;
        const { Region } = await import(`${url}/region-front/index.js`);

        Region.header.mount();
        Region.footer.mount();
    } catch (e: unknown) {
        if (e instanceof Error) {
            console.log(e.message);
        }
    }
};

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

importRegion();
